import React, { useState } from 'react';
import { css } from '@emotion/react';
import { shallowEqual } from 'react-redux';
import useTranslation from 'next-translate/useTranslation';
import BottomSheetContainer from '@components/commons/popup/container/BottomSheetContainer';
import theme from '@styles/theme';
import useLocalStorage from '@hooks/useLocalStorage';
import { STORAGE_KEY } from '@common/values';
import { useAppSelector } from '@store/hooks';
import { RootState } from '@store/store';

const TTSGuide = () => {
  const { playChapterInfo } = useAppSelector(
    (state: RootState) => state.chapter,
    shallowEqual,
  );
  const [isPlayTTS, setPlayTTS] = useLocalStorage(STORAGE_KEY.IS_PLAY_TTS);
  const { t } = useTranslation();
  const [isCloseClick, setIsCloseClick] = useState(false);

  if (
    !playChapterInfo?.hasTTS ||
    (isPlayTTS && JSON.parse(isPlayTTS) === true)
  ) {
    return null;
  }

  const onClose = () => {
    setPlayTTS('true');
  };

  const onClosePopup = () => {
    setIsCloseClick(true);
    setTimeout(() => {
      onClose();
    }, 450);
  };

  return (
    <BottomSheetContainer
      title={t('chat_popup_title_tts_guide')}
      isCloseButtonClick={isCloseClick}
      isTitleHasUnderline={false}
    >
      <div css={container}>
        <p className="description">{t('chat_popup_label_tts_guide')}</p>
        <button className="button" onClick={onClosePopup}>
          {t('common_screen_title_confirm')}
        </button>
      </div>
    </BottomSheetContainer>
  );
};

const container = css`
  display: flex;
  flex-direction: column;

  .description {
    font-family: 'Apple SD Gothic Neo';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 20px;
  }

  .button {
    background-color: ${theme.colors.primary500};
    color: ${theme.colors.white};
    width: 100%;
    height: 52px;
    border-radius: 8px;
    font-family: 'Apple SD Gothic Neo';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    cursor: pointer;
  }
`;

export default TTSGuide;
